import { render, staticRenderFns } from "./ticketsDetails.vue?vue&type=template&id=779d7973&scoped=true&"
import script from "./ticketsDetails.vue?vue&type=script&lang=js&"
export * from "./ticketsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ticketsDetails.vue?vue&type=style&index=0&id=779d7973&scoped=true&lang=css&"
import style1 from "./ticketsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d7973",
  null
  
)

export default component.exports